import * as R from 'remeda';
import { IntlShape } from 'react-intl';
import { GridPreProcessEditCellProps } from '@rossum/ui/x-data-grid-pro';

// both functions taken from elis-frontend
const limitPercentageDecimalPlaces = (num: number) =>
  parseFloat(num.toFixed(1));

const limitFloatDecimalPlaces = (num: number) => parseFloat(num.toFixed(3));

export const valueToPercentage = <T>(value: T) =>
  R.isNumber(value) && Number.isFinite(value)
    ? limitPercentageDecimalPlaces(value * 100)
    : value;

export const percentageToValue = (value: unknown) => {
  const valueAsNumber = Number(value);

  return value !== null &&
    R.isNumber(valueAsNumber) &&
    Number.isFinite(valueAsNumber)
    ? limitFloatDecimalPlaces(valueAsNumber / 100)
    : undefined;
};

export const appendPercentSignToNumber = <O extends number | null | undefined>(
  value: O
) => (R.isNumber(value) ? `${value} %` : undefined);

export const validatePercentageRange =
  (fieldName: string, intl: IntlShape) =>
  (params: GridPreProcessEditCellProps) => {
    const hasError = params.props.value < 0 || params.props.value > 100;

    return {
      ...params.props,
      error: hasError,
      errorMessage: intl.formatMessage(
        {
          id: 'features.fieldManager.fieldDetail.columns.percentages.validatePercentageRange.error',
        },
        { fieldName }
      ),
    };
  };
